//Dependencies
import React, { useEffect, useCallback, useState } from 'react';
import { Map, TileLayer, Marker, Tooltip, CircleMarker } from "react-leaflet";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Icon } from "leaflet";

const markerGreen = new Icon(
  {
    iconUrl: 'https://firebasestorage.googleapis.com/v0/b/spot360vlog.appspot.com/o/icons%2Fmarker06.png?alt=media&token=51e91fdd-4d2d-45f9-8026-b4c015fd6fb9',
    shadowUrl: 'https://firebasestorage.googleapis.com/v0/b/spot360vlog.appspot.com/o/icons%2Fshadow.png?alt=media&token=8db7febe-7d7a-4b96-9dbe-30136809114c',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [1, -34],
    shadowSize: [40, 40]
  });

const markerBlue = new Icon(
  {
    iconUrl: 'https://firebasestorage.googleapis.com/v0/b/spot360vlog.appspot.com/o/icons%2Fmarker04.png?alt=media&token=bb251932-2667-4584-9c88-090476ad2d83',
    shadowUrl: 'https://firebasestorage.googleapis.com/v0/b/spot360vlog.appspot.com/o/icons%2Fshadow.png?alt=media&token=8db7febe-7d7a-4b96-9dbe-30136809114c',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [1, -34],
    shadowSize: [40, 40]
  });

const MapPage01 = (props) =>
{
  const dispatch = useDispatch(); 
  const navigate = useNavigate(); 

  const { branches, center, height, influencer, filter, last, paddingBottom, paddingTop, zoom, markers, location } = props;  
  const layers = useSelector(state => state.map.layers); 
  
  const layer1 = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
  const layer2 = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

  const [ markerList01, setMarkerList01 ] = useState(null);
  const [ markerList02, setMarkerList02 ] = useState(null);
  const [ markerList03, setMarkerList03 ] = useState(null);
  const [ markerList04, setMarkerList04 ] = useState(null);
  const [ markerList05, setMarkerList05 ] = useState(null);

  const clickMarker = useCallback((data) => 
  {
    navigate(`/${data.info.username}${data.info.branchurl ? `?s=${data.info.branchurl}` : ''}`);
  }, [navigate]); 

  const clickMarkerInfluencer = useCallback((data, by) => 
  {
    navigate(`/${data.info.username}${data.info.branchurl ? `?s=${data.info.branchurl}&by=` : '?by='}${by}`);
  }, [navigate]); 

  const clickMarkerFilter = useCallback((data, filter) => 
  {
    navigate(`/${data.info.username}${data.info.branchurl ? `?s=${data.info.branchurl}&f=` : '?f='}${filter}`);
  }, [navigate]); 
  
  /* ALL MARKERS */
  useEffect(() => 
  {
    let markerArray01 = [];
    let markerArray02 = [];

    try
    {
      for(let i = 0; i < Object.keys(markers).length; i++)
      {
        let data = markers[Object.keys(markers)[i]];

        let marker01 = 
        (
          <Marker
            key = {i}
            position = {data.info.location}
            icon = {markerGreen}
            onClick = {() => clickMarker(data)}
          />
        )

        let marker02 = 
        (
          <Marker
            key = {i}
            position = {data.info.location}
            icon = {markerGreen}
            onClick = {() => clickMarker(data)}
          >
            <Tooltip direction = "bottom" permanent>
              {`${data.info.name.toUpperCase()}`}
            </Tooltip>
          </Marker>
        )
        
        markerArray01.push({...marker01});
        markerArray02.push({...marker02});
      };

      setMarkerList01(markerArray01);
      setMarkerList02(markerArray02);
    } 
    catch (error) 
    {
      //console.log(error);
    }    
  }, [markers, clickMarker]);

  /* BRANCHES MARKERS */
  useEffect(() => 
  {
    if (!branches) 
    {
      setMarkerList03(null);
      return null;
    }
    let markerArray03 = [];

    try
    {
      for(let i = 0; i < Object.keys(branches).length; i++)
      {
        let data = branches[i];

        let marker01 = 
        (
          <Marker
            key = {i}
            position = {data.info.location}
            icon = {markerBlue}
            onClick = {() => clickMarker(data)}
          >
            <Tooltip direction = "bottom" permanent>
              {`${data.info.name.toUpperCase()}`}
            </Tooltip>
          </Marker>
        )

        markerArray03.push({...marker01});
      };
      
      setMarkerList03(markerArray03);
    } 
    catch (error) 
    {
      //console.log(error);
    }    
  }, [branches, clickMarker]);

  /* INFLUENCERS MARKERS */
  useEffect(() => 
  {
    if (!influencer) 
    {
      setMarkerList04(null);
      return null;
    }

    let markerArray04 = [];    

    try
    {
      for(let i = 0; i < Object.keys(markers).length; i++)
      {
        let influencerContent = false;
        
        let data = markers[Object.keys(markers)[i]];

        let influencerMatch = Object.keys(data.influencers.tiktok).find(f1 => data.influencers.tiktok[f1].username === influencer);
        if(influencerMatch) influencerContent = true;        
       
        let marker04 = 
        (
          <Marker
            key = {i}
            position = {data.info.location}
            icon = {markerBlue}
            onClick = {() => clickMarker(data)}
          >
            <Tooltip direction = "bottom" permanent>
              {`${data.info.name.toUpperCase()}`}
            </Tooltip>
          </Marker>
        )
        
        if(influencerContent) markerArray04.push({...marker04});
      };

      setMarkerList04(markerArray04);
    } 
    catch (error) 
    {
      //console.log(error);
    }    
  }, [influencer, markers, clickMarker, clickMarkerInfluencer]);

  /* FILTERS MARKERS */
  useEffect(() => 
  {
    if (!filter) 
    {
      setMarkerList05(null);
      return null;
    }

    let markerArray05 = [];    

    try
    {
      for(let i = 0; i < Object.keys(markers).length; i++)
      {
        let filterContent = false;
        
        let data = markers[Object.keys(markers)[i]];

        let filterMatch = data.info.subtype === filter;
        if(filterMatch) filterContent = true;
       
        let marker05 = 
        (
          <Marker
            key = {i}
            position = {data.info.location}
            icon = {markerBlue}
            onClick = {() => clickMarker(data)}
          >
            <Tooltip direction = "bottom" permanent>
              {`${data.info.name.toUpperCase()}`}
            </Tooltip>
          </Marker>
        )
        
        if(filterContent) markerArray05.push({...marker05});
      };

      setMarkerList05(markerArray05);
    } 
    catch (error) 
    {
      //console.log(error);
    }    
  }, [filter, markers, clickMarker, clickMarkerFilter]);

  const dragMap = useCallback((e) => 
  {
    dispatch({type: 'SET_CENTER', center : e.target.getCenter()});
  }, [dispatch]); 

  const mapZoom = (e) =>
  {
    dispatch({type: 'SET_ZOOM', zoom : e.target.getZoom()});
  }
  return(
    <div
      style = {{height : height, width : '100%', paddingTop : paddingTop, paddingBottom : paddingBottom }}
    >
      <Map
        center = {center} 
        zoom = {zoom} 
        style = {{height : '100%', width : '100%'}}
        onzoomend = {(e) => mapZoom(e)} 
        ondragend = {(e) => dragMap(e)}
      >
        <TileLayer
          url = {layers ? layer2 : layer1}
          minZoom = {5}
          maxZoom = {19}
        />

        {!influencer && !filter && !branches && zoom < 15 && markerList01}
        {!influencer && !filter && !branches && zoom > 13 && markerList02}
        {branches && markerList03}
        {influencer && markerList04}
        {filter && markerList05}

        {location &&
          <CircleMarker
            center = {location}
            radius = {20}
            fill = "true"
            color = '#4666FF'
            fillColor = '#4666FF'
            opacity = {1}
            fillOpacity = {0.8}
            weight = {2}
          >
            <Tooltip direction = "bottom" permanent>
              TU UBICACIÓN
            </Tooltip>
          </CircleMarker>
        }

        {last &&
          <CircleMarker
            center = {last.info.location}
            radius = {20}
            fill = "true"
            color = '#ff6700'
            fillColor = '#ff6700'
            opacity = {1}
            fillOpacity = {0.4}
            weight = {2}
            eventHandlers = 
            {{
              click: () => 
              {
                clickMarker(last)
              },
            }}
          >
            <Tooltip direction = "bottom" permanent>
              {`${last.info.name.toUpperCase()}`}
            </Tooltip>
          </CircleMarker>
        }
      </Map>
    </div>
  );
}

export default MapPage01;